const env = process.env.NODE_ENV
var url = 'http://localhost:17072';
// var url = 'https://prizeback.aojuai.com';
const config = {
  development:{
    // baseURL :url//本地
    baseURL :url //线上 
  },
  production:{
     baseURL :'https://prizeback.aojuai.com'
    //  baseURL :'http://localhost:17072'
  }
}
export default {
  baseURL:config[env].baseURL
}